import type { GuideConfig } from './types';
import { suitGuide } from './suitGuide';
import { jewelryGuide } from './jewelryGuide';
import { hanbokGuide } from './hanbokGuide';

export const categoryGuides: Record<string, GuideConfig> = {
  suit: suitGuide,
  jewelry: jewelryGuide,
  hanbok: hanbokGuide,
};

export function getGuideConfig(categoryKey: string): GuideConfig | undefined {
  return categoryGuides[categoryKey];
}